export default ({ request }) => ({
  orderBatchListApi(data = {}) {
    return request({
      url: '/factory/orderBatch/list',
      method: 'post',
      data
    })
  },
  orderBatchDetailApi(data = {}) {
    return request({
      url: '/factory/orderBatch/detail',
      method: 'post',
      data
    })
  },
  orderBatchSaveApi(data = {}) {
    return request({
      url: '/factory/orderBatch/save',
      method: 'post',
      data
    })
  },
  orderBatchDelApi(data = {}) {
    return request({
      url: '/factory/orderBatch/del',
      method: 'post',
      data
    })
  },

  orderBatchGoodsListApi(data = {}) {
    return request({
      url: '/factory/orderBatchGoods/list',
      method: 'post',
      data
    })
  },
  orderBatchGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/orderBatchGoods/detail',
      method: 'post',
      data
    })
  },
  orderBatchGoodsAddApi(data = {}) {
    return request({
      url: '/factory/orderBatchGoods/add',
      method: 'post',
      data
    })
  },
  orderBatchGoodsModiApi(data = {}) {
    return request({
      url: '/factory/orderBatchGoods/modi',
      method: 'post',
      data
    })
  },
  orderBatchGoodsAddListApi(data = {}) {
    return request({
      url: '/factory/orderBatchGoods/addList',
      method: 'post',
      data
    })
  },
  orderBatchGoodsDelApi(data = {}) {
    return request({
      url: '/factory/orderBatchGoods/del',
      method: 'post',
      data
    })
  },
  addBatchGoodsByPackingCodeApi(data = {}) {
    return request({
      url: '/factory/orderBatch/addBatchGoodsByPackingCode',
      method: 'post',
      data,
      timeout: 30 * 1000,
    })
  },
  orderBatchGoodsCheckDataApi(data = {}) {
    return request({
      url: '/factory/orderBatch/checkData',
      method: 'post',
      data
    })
  },
  orderBatchPendingListApi(data = {}) {
    return request({
      url: '/factory/orderBatch/pending/list',
      method: 'post',
      data
    })
  },
  orderBatchShipmentPlanListApi(data = {}) {
    return request({
      url: '/factory/orderBatch/shipment/plan/list',
      method: 'post',
      data
    })
  },
})
